var AddressGiftForm = (function (CheckoutApiCollection, Decoration, PromiseUtil, CheckoutSettings) {
    return CheckoutApiCollection.extend({
        model: Decoration,

        initialize: function () {
            this._saving = null;
        },

        save: function () {
            if (this._saving) {
                return this._saving.promise();
            } else if (!this.isValid()) {
                window.app && app.event && app.event.addressValidation(0);
                return PromiseUtil.rejected();
            }

            window.app && app.event && app.event.addressValidation(1);

            var address = {};

            this.each(function (m) {
                var name = m.get('Name');
                address[name] = m.getHidden() === true ? '' : m.get('Value');

                //if (name === 'GiftMessage') {
                //    var message = m.get('Value') || '';
                //    address.AdditionalData = JSON.stringify({ GiftMessage: message.replace(/^\s+|\s+$/g, '') });
                //} else {
                //    address[name] = m.getHidden() === true ? '' : m.get('Value');
                //}

            });

            this._saving = this._api.setUserGiftAddress(address);

            setTimeout(_.bind(function () {
                this._saving.done(_.bind(this._updateCheckout, this))
                    .always(_.bind(function () {
                        this._saving = null;
                    }, this));
            }, this), 0);

            return this._saving.promise();
        },

        isValid: function () {
            var isValid = true;

            this.each(function (model) {
                isValid &= model.isValid();
            });

            this.trigger('isValid', isValid);
            return isValid;
        },

        isActive: function () {
            return this._isActive;
        },

        setActive: function (isActive) {
            this._isActive = isActive;
            this.trigger('isActive', isActive);
        },

        setDecoration: function () {
            var decoration = CheckoutSettings.getDecoration();

            if (!this.__ready) {
                this.__ready = true;
                this.update(decoration.Gift);
            }
        }

    });
})(CheckoutApiCollection, Decoration, PromiseUtil, CheckoutSettings);
